import * as React from "react";
import { useTheme } from "@mui/material";

const PowerIcon: React.FC = function (): React.ReactElement {
  const theme = useTheme();
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.70981 0.477386C1.78835 0.619928 1.82959 0.781129 1.82946 0.94512C1.82981 1.10363 1.79129 1.25965 1.71748 1.39864C1.64367 1.53763 1.53697 1.65507 1.40733 1.74V15H0.422124V1.74C0.288272 1.65169 0.179006 1.52891 0.105082 1.38376C0.0311585 1.23861 -0.0048749 1.07608 0.000529656 0.912187C0.00593421 0.748291 0.0525902 0.588672 0.135905 0.449046C0.219219 0.309419 0.336321 0.194598 0.47568 0.115885C0.615039 0.0371731 0.771851 -0.00271635 0.93068 0.000143651C1.08951 0.00300365 1.24488 0.0485146 1.38149 0.132196C1.51811 0.215878 1.63126 0.334845 1.70981 0.477386ZM6.82686 10.3877C3.67647 10.3877 2.34265 11.6935 2.34265 11.6935V2.12591C3.87882 0.511105 5.98034 0.288913 10.7745 2.00699C14.7654 3.44263 16.7615 1.84034 16.7615 1.84034C15.5 6.5 12.8518 6.80289 12.8518 6.80289C13.3353 8.67822 16.1636 11.7529 16.1636 11.7529C15.8415 11.8953 14.876 12.1089 14.1977 12.0729C12.8739 12.0034 11.8654 11.6305 10.8447 11.2531C9.68237 10.8233 8.50427 10.3877 6.82686 10.3877Z"
        fill={theme.palette.primary.main}
      />
    </svg>
  );
};

export default PowerIcon;
